import script from "./ImageSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageSelector.vue?vue&type=script&setup=true&lang=js"

import "./ImageSelector.vue?vue&type=style&index=0&id=0b702df6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b702df6"]])

export default __exports__